import { collections } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="高清中字合集"
          title="按主题打包的伦理片合集，省去逐部挑片的时间"
          desc="如果你对题材已经有大致偏好，直接从合集入手更高效。每个合集都标注了收录数量与三条主线，点开任意一个主题，就能看到同一气质下的一整组推荐。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
          {collections.map((collection) => (
            <article
              key={collection.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-400"
            >
              <div className="h-44 w-full overflow-hidden bg-background-200 md:h-52">
                <img
                  src={collection.cover}
                  alt={`${collection.name} 合集封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-lg text-foreground-950">{collection.name}</h3>
                  <span className="shrink-0 rounded-full bg-primary-100 px-2.5 py-1 font-label text-xs text-primary-700">
                    共 {collection.count} 部
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{collection.desc}</p>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {collection.highlights.map((point) => (
                    <li
                      key={point}
                      className="flex items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700"
                    >
                      <i className="ri-bookmark-line text-secondary-600"></i>
                      {point}
                    </li>
                  ))}
                </ul>
                <div className="mt-5 flex items-center gap-2 border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  合集内条目均支持中字高清观看，持续补充新片
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}